import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';
import { IProduct } from '../../../../../interfaces/Product.interfaces';

interface ProductCategoryAndSpecSectionProps {
  product: IProduct;
  category: 'PLUVA' | 'PARTNER';
}

export const ProductCategoryAndSpecSection = ({ product, category }: ProductCategoryAndSpecSectionProps) => {
  return (
    <Container>
      <CategoryIntroduce>
        {category === 'PLUVA' ? (
          <>
            <CategoryIntroduceHeader>
              <Icon name="PluvaTractor1" width={18} height={18} />
              <CategoryIntroduceTitleContainer>
                <CategoryIntroduceTitle color={'#445EFF'}>{'플루바 마켓'}</CategoryIntroduceTitle>
                <CategoryIntroduceTitle>{'이 직매입 한 프리미엄 매물!'}</CategoryIntroduceTitle>
              </CategoryIntroduceTitleContainer>
            </CategoryIntroduceHeader>
            <CategoryIntroduceDescription>
              {'꼼꼼하게 점검과 수리를 거쳐\n상품화 작업을 마친 프리미엄 매물입니다.'}
            </CategoryIntroduceDescription>
          </>
        ) : (
          <>
            <CategoryIntroduceHeader>
              <Icon name="Partner1" width={18} height={18} />
              <CategoryIntroduceTitleContainer>
                <CategoryIntroduceTitle>{'플루바 마켓이 '}</CategoryIntroduceTitle>
                <CategoryIntroduceTitle color={'#34C77E'}>{'인증한 협력사 '}</CategoryIntroduceTitle>
                <CategoryIntroduceTitle>{'매물!'}</CategoryIntroduceTitle>
              </CategoryIntroduceTitleContainer>
            </CategoryIntroduceHeader>
            <CategoryIntroduceDescription>
              {'믿을 수 있는 협력사의 매물을\n할부 서비스와 함께 구매 해보세요!'}
            </CategoryIntroduceDescription>
          </>
        )}
      </CategoryIntroduce>
      <ProductSpecSummary>
        <ProductSpecWrapper>
          <Icon name="PDPYearLight2" width={48} height={48} />
          <ProductSpecTitleAndDescription>
            <ProductSpecTitle>{'연식'}</ProductSpecTitle>
            <ProductSpecDescription>{`${product.manufacturedYear}년식`}</ProductSpecDescription>
          </ProductSpecTitleAndDescription>
        </ProductSpecWrapper>
        <ProductSpecWrapper>
          <Icon name="PDPTimeLight2" width={48} height={48} />
          <ProductSpecTitleAndDescription>
            <ProductSpecTitle>{'사용시간'}</ProductSpecTitle>
            <ProductSpecDescription>{`${product.operationTime.toLocaleString()}시간`}</ProductSpecDescription>
          </ProductSpecTitleAndDescription>
        </ProductSpecWrapper>
        <ProductSpecWrapper>
          <Icon name="PDPPSLight2" width={48} height={48} />
          <ProductSpecTitleAndDescription>
            <ProductSpecTitle>{'마력'}</ProductSpecTitle>
            <ProductSpecDescription>{`${product.machine?.engineOutputInPs}마력`}</ProductSpecDescription>
          </ProductSpecTitleAndDescription>
        </ProductSpecWrapper>
      </ProductSpecSummary>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  padding: 0px var(--radius-large, 16px) 40px var(--radius-large, 16px);

  gap: 24px;
`;

const CategoryIntroduce = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  padding: 32px 0px;

  gap: var(--radius-medium, 8px);

  border-radius: var(--radius-medium, 8px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
`;

const CategoryIntroduceHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);
  align-self: stretch;
`;

const CategoryIntroduceTitleContainer = styled.span``;

const CategoryIntroduceTitle = styled.span<{ color?: string }>`
  color: ${(props) => (props.color ? props.color : '#232429')};

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const CategoryIntroduceDescription = styled.pre`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const ProductSpecSummary = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
`;

const ProductSpecWrapper = styled.div`
  display: flex;
  padding: 0px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
  flex: 1 0 0;
`;

const ProductSpecTitleAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
`;

const ProductSpecTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* System/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 11.9px */
`;

const ProductSpecDescription = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 13.6px */
`;
